import styled from 'styled-components';

export type BadgeProps = {};

export const Badge = styled.span.attrs<BadgeProps>((props) => ({ className: 'app-badge' }))`
    &.app-badge {
        font-size: 0.71em;
        display: flex;
        align-items: center;
        text-transform: uppercase;

        padding: 0.14em 0.57em;
        margin: 0 0.57em;

        font-style: normal;
        font-weight: 500;
        line-height: 1em;

        color: ${(props) => props.theme.colors.road_grey_900};
        background: ${(props) => props.theme.colors.road_grey_080};
    }
`;
